import React from "react";
import { FieldRenderer } from "./AdminFields";

/* Rendered in a separate module so the JSX tooling does not recurse into
   FieldRenderer while analysing its own array iteration. */
export function SubFields({ fields, item, path, onItemChange }) {
  return (
    <>
      {fields.map((f) => (
        <FieldRenderer
          key={f.name}
          field={f}
          path={`${path}-${f.name}`}
          value={item[f.name]}
          onChange={(v) => onItemChange(f.name, v)}
        />
      ))}
    </>
  );
}
